import { LiveStatsDataBuilder } from './live-stats-data.builder';
var LiveStatsBuilder = /** @class */ (function () {
    function LiveStatsBuilder() {
        this.liveStats = {
            callbackStats: new LiveStatsDataBuilder().build(),
            inboundStats: new LiveStatsDataBuilder().build(),
            outboundStats: new LiveStatsDataBuilder().build(),
            agentsStatus: {},
            customBusyStatus: {}
        };
    }
    LiveStatsBuilder.prototype.withCallbackStats = function (callbackStats) {
        this.liveStats.callbackStats = callbackStats;
        return this;
    };
    LiveStatsBuilder.prototype.withInboundStats = function (inboundStats) {
        this.liveStats.inboundStats = inboundStats;
        return this;
    };
    LiveStatsBuilder.prototype.withOutboundStats = function (outboundStats) {
        this.liveStats.outboundStats = outboundStats;
        return this;
    };
    LiveStatsBuilder.prototype.build = function () {
        return this.liveStats;
    };
    return LiveStatsBuilder;
}());
export { LiveStatsBuilder };
//# sourceMappingURL=live-stats.builder.js.map